import { Component, input, effect } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BaseIntegrationSystem } from '@pages/create/base-item-creation.component';

export type IntegrationSystem = {
  name: string;
  status: 'completed' | 'in-progress' | 'pending' | 'failed';
  statusText: string;
};

@Component({
  selector: 'md-integration',
  templateUrl: './integration.component.html',
  standalone: true,
  imports: [MatIconModule, CommonModule, TranslateModule],
  styleUrls: ['./integration.component.scss']
})
export class IntegrationComponent {
  systems = input<readonly BaseIntegrationSystem[]>([]);

  constructor() {
    effect(() => {
      const currentSystems = this.systems();
      console.log('[IntegrationComponent] Systems updated:', currentSystems);
    });
  }
}
